import { Select, SelectProps } from "@mantine/core";

type Props = SelectProps;

export const SelectRounded = (props: Props) => {
  return <Select
    styles={{
      input: {
        borderRadius: "12px",
      },
      label: {
        paddingLeft: "12px",
      }
    }}
    {...props}
  />
}
